export const normalizeError = (error, fallbackMessage = 'Unexpected error') => {
  if (!error) {
    return { message: fallbackMessage, status: undefined }
  }

  if (error.normalized) {
    return {
      message: error.normalized.message || fallbackMessage,
      status: error.normalized.status,
      data: error.normalized.data,
      code: error.normalized.status,
    }
  }

  if (error.response) {
    return {
      message: error.response.data?.message ?? fallbackMessage,
      status: error.response.status,
      data: error.response.data,
      code: error.response.status,
    }
  }

  if (error instanceof Error) {
    return {
      message: error.message ?? fallbackMessage,
      status: error.status,
      code: error.code,
    }
  }

  if (typeof error === 'string') {
    return { message: error }
  }

  return {
    message: error.message ?? fallbackMessage,
    status: error.status,
    code: error.code,
  }
}

export const isUnauthorizedError = (error) => {
  const normalized = normalizeError(error)
  return normalized.status === 401 || normalized.status === 403
}

export default normalizeError
